import { gql } from '@apollo/client';

export const FETCH_PROCESS_AREA_DASHBOARD = gql`
  query ProcessAreaDashboard {
    findAll: processAreaDashboard {
      locationName
      totalRevenue
      processAreas
      processes
      uuid
    }
  }
`;

export const GET_ALL_LOCATIONS = gql`
  query GetLocations {
    findAllLocations {
      uuid
      locationName
    }
  }
`;

export const GET_LOCATIONS_TO_MITIGATE = gql`
  query GetLocationsToMitigate($data: FilterLocationInput!) {
    getLocationsByDivisionAndParent(data: $data) {
      locationId
    }
  }
`;

export const ASSIGN_LOCATIONS_TO_MIITGATE = gql`
  mutation AssignLocationsToMitigate($data: AssignLocationInput!) {
    assignLocations(data: $data) {
      locationId
    }
  }
`;

export const UNASSIGN_LOCATIONS_TO_MIITGATE = gql`
  mutation UnassignLocationsToMitigate($data: RemoveLocationInput!) {
    removeLocations(data: $data)
  }
`;
